/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    '#pr-reviewdisplay': {
        '.p-w-r': {
            fontFamily: 'lato',
            '.pr-review-snapshot,  .pr-review-display': {
                backgroundColor: 'unset'
            }
        },
        '.pr-snippet-stars': {
            backgroundColor: 'unset',
            margin: '0'
        },
        '.pr-review-snapshot-header': {
            padding: '0',
            margin: '0',
            '.pr-headline': {
                color: 'black',
                fontSize: {base: '2xl', md: 'fontSize32'},
                fontWeight: 'extrabold',
                lineHeight: '10'
            },
            '.pr-review-snapshot-header-intro': {
                border: 'none',
                padding: '0',
                mb: {base: '6', md: '12'},
                justifyContent: 'space-between'
            },
            '.pr-subheadline': {
                width: '10',
                height: '10',
                backgroundSize: '40px',
                backgroundRepeat: 'no-repeat'
            },
            '.pr-subheadline svg': {
                display: 'none'
            }
        },
        '.pr-review-snapshot .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
            width: '6',
            height: '6',
            padding: '0',
            margin: '0'
        },
        '.p-w-r .pr-review-display .pr-star-v4': {
            width: '5',
            height: '5',
            padding: '0',
            margin: '0'
        },
        '.pr-review-snapshot-simple': {
            margin: '0'
        },
        '.pr-review-snapshot-block-container': {
            display: {base: 'block', md: 'flex'},
            mb: {base: '0', md: '16'},
            '.pr-review-snapshot-block': {
                padding: {base: '24px 0', md: '0 24px', lg: '0 48px'},
                borderRight: {base: 'none', md: '1px solid rgba(0, 0, 0, 0.20)'},
                borderBottom: {base: '1px solid rgba(0, 0, 0, 0.20)', md: 'none'},
                marginBottom: '0'
            },
            '.pr-review-snapshot-block-snippet': {
                paddingLeft: '0',
                paddingTop: 0,
                width: {base: '100%', md: '232px', lg: '348px'},
                minHeight: 'unset',
                display: 'flex',
                '.pr-review-snapshot-snippets': {
                    '.pr-review-snapshot-snippets-headline': {
                        fontSize: '56px',
                        fontWeight: 'extrabold',
                        lineHeight: '80px',
                        marginBottom: '4',
                        display: {base: 'none', md: 'block'},
                        color: 'black'
                    },
                    '.pr-snippet-stars-container': {
                        '.pr-snippet-stars-png': {
                            display: {base: 'flex', md: 'block'},
                            alignItems: 'center',
                            '.pr-rating-stars': {
                                order: '2'
                            },
                            '.pr-snippet-rating-decimal': {
                                display: {base: 'block', md: 'none'},
                                order: '1',
                                fontSize: '40px',
                                fontWeight: 'extrabold',
                                lineHeight: '52px',
                                background: 'none',
                                border: 'none',
                                color: '#000',
                                padding: '0',
                                margin: '0 16px 0 0'
                            }
                        }
                    },
                    '.pr-snippet-review-count': {
                        margin: {base: '8px 0', md: '16px 0'},
                        fontSize: 'xl',
                        fontWeight: 'extrabold',
                        lineHeight: '7',
                        color: '#000',
                        textAlign: 'center'
                    },
                    '.pr-snippet-write-review-link': {
                        backgroundColor: 'unset',
                        color: 'black',
                        padding: 0,
                        fontSize: 'xl',
                        lineHeight: '7',
                        border: 'none',
                        fontWeight: 'normal',
                        textDecoration: 'underline'
                    }
                }
            },
            '.pr-review-snapshot-block-recommend': {
                width: {base: '100%', md: '284px', lg: '398px'},
                minHeight: 'auto',
                '.pr-review-snapshot-recomend': {
                    width: '100%'
                },
                '.pr-snippet-reco-to-friend-green': {
                    backgroundColor: 'unset',
                    width: '100%',
                    textAlign: 'center',
                    padding: '0'
                },
                '.pr-checkbox-icon': {
                    display: 'none !important'
                },
                '.pr-reco-green': {
                    padding: '0',
                    '.pr-reco-value': {
                        fontSize: {base: '40px', md: '56px'},
                        fontWeight: 'extrabold',
                        lineHeight: {base: '52px', md: '80px'},
                        marginBottom: {base: '0', md: '4'},
                        color: '#000'
                    }
                },
                '.pr-reco-to-friend-message': {
                    fontSize: 'xl',
                    fontWeight: 'medium',
                    lineHeight: '8',
                    backgroundColor: 'unset',
                    maxWidth: {base: '100%', md: '200px'},
                    padding: '0',
                    textAlign: 'center',
                    width: '100%',
                    margin: '0 auto'
                }
            },
            '.pr-review-snapshot-block-histogram': {
                display: 'Flex',
                paddingRight: '0',
                paddingBottom: {base: '6', md: '0'},
                borderRight: 'none',
                borderBottom: {base: '1px solid rgba(0, 0, 0, 0.20)', md: 'none'},
                width: {base: '100%', md: 'calc(100% - 516px)', lg: 'calc(100% - 746px)'},
                marginBottom: '0',
                '.pr-review-snapshot-histogram': {
                    width: '100%'
                },
                '.pr-ratings-histogram-list-item': {
                    mb: '2'
                },
                '.pr-histogram-label': {
                    fontSize: 'xl',
                    padding: '0 16px 0 0'
                },
                '.pr-histogram-cross': {
                    display: 'none'
                },
                '.pr-histogram-count': {
                    fontSize: 'xl',
                    padding: '0 0 0 16px',
                    color: '#000',
                    fontWeight: 'extrabold',
                    lineHeight: '7'
                },
                '.pr-ratings-histogram-bar': {
                    height: '5',
                    '.pr-ratings-histogram-barValue': {
                        height: '5',
                        background: '#FF640A'
                    }
                }
            }
        },
        '.pr-rd-main-header': {
            display: 'flex',
            flexDirection: 'column',
            padding: {base: '24px 0', md: '0'},
            margin: '0',
            backgroundColor: 'unset',
            '.pr-rd-review-total': {
                width: '100%',
                padding: {base: '24px 0 0', md: '32px 0'},
                borderTop: {base: 'none', md: '1px solid #DADADA'},
                order: 2,
                marginTop: {base: '0', md: '8'},
                fontSize: 'xl',
                fontWeight: 'extrabold',
                lineHeight: '7',
                marginBottom: '0',
                display: 'block',
                '+ .pr-rd-right': {
                    order: '1',
                    width: '100%',
                    '.pr-rd-sort-group': {
                        float: 'right',
                        width: {base: '100%', md: 'auto'}
                    }
                }
            },
            '.pr-rd-sort-group': {
                position: 'relative',
                paddingTop: {base: '16px', md: '0'}
            },
            '.pr-rd-sort-group:before': {
                content: '""',
                position: 'absolute',
                width: '20px',
                height: '20px',
                left: '16px',
                top: '12px',
                display: {base: 'none', md: 'block'}
            },
            '.pr-rd-sort': {
                borderRadius: 'lg',
                padding: {base: '13px 52px 13px 16px', md: '13px 52px'},
                fontWeight: 'extrabold',
                lineHeight: '5',
                appearance: 'none',
                border: '1px solid #59595b',
                backgroundPosition: 'center right 20px',
                backgroundRepeat: 'no-repeat',
                margin: '0',
                width: {base: '100%', md: 'auto'},
                minWidth: {base: 'unset', md: '150px'},
                maxWidth: {base: '100%', md: '200px'},
                fontSize: 'md',
                backgroundColor: 'unset'
            },
            '.pr-rd-main-header-search': {
                width: {base: '100%', md: '75%', lg: '62%'},
                padding: '0'
            },
            '.pr-rd-review-header-sorts': {
                width: {base: '100%', md: '25%', lg: '37%'},
                padding: '0',
                float: 'right'
            },
            '.pr-rd-search-reviews-input': {
                height: '48px !important',
                borderRadius: '8px',
                border: '1px solid #59595b',
                input: {
                    height: '100% !important',
                    border: '0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    padding: '10px 62px 10px 16px'
                }
            },
            '.pr-rd-search-reviews-icon-button': {
                background: '#000',
                border: '0',
                width: '52px',
                height: '100% !important',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',

                '.pr-search-icon': {
                    width: '24px'
                },
                svg: {
                    transform: 'none',
                    width: '24px',
                    height: '24px'
                }
            }
        },
        '#pr-review-display': {
            '.pr-rd-no-reviews': {
                padding: '0 0 24px 0',
                '.pr-snippet-write-review-link': {
                    fontWeight: 'medium',
                    lineHeight: '6',
                    color: '#000',
                    fontSize: 'md',
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px'
                }
            },
            '.pr-review': {
                padding: {base: '8px 0 24px 0', md: '16px 0 24px 0'},
                borderTop: '1px solid #000',
                margin: '0',
                ':last-child': {
                    paddingBottom: '0'
                },
                '.pr-rd-header.pr-rd-content-block': {
                    width: '100%',
                    display: {base: 'block', md: 'flex'},
                    alignItems: 'center',
                    marginBottom: {base: '2', md: '4'},
                    '.pr-rd-star-rating': {
                        width: '164px',
                        '.pr-rating-stars': {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '3px 0px'
                        },
                        '.pr-snippet-rating-decimal': {
                            backgroundColor: 'unset',
                            border: 'none',
                            fontWeight: 'extrabold',
                            lineHeight: '6',
                            height: 'auto'
                        }
                    },
                    '.pr-rd-review-headline': {
                        fontSize: '2xl',
                        fontWeight: 'extrabold',
                        lineHeight: '8',
                        paddingLeft: {base: '0', md: '4'},
                        margin: '0',
                        width: {base: '100%', md: 'auto'}
                    }
                },
                '.pr-rd-content-block': {
                    width: '100%',
                    margin: '0',
                    '&.pr-rd-description': {
                        '.pr-rd-side-content-block': {
                            right: 'unset',
                            left: '0',
                            padding: '0',
                            width: {base: '100%', md: '164px'},
                            position: {base: 'relative', md: 'absolute'},
                            marginBottom: {base: '4', md: '0'},
                            '.pr-rd-reviewer-details': {
                                display: 'flex',
                                flexDirection: {base: 'unset', md: 'column'},
                                marginBottom: '1',
                                '.pr-rd-author-location-undisclosed, .pr-rd-author-location': {
                                    display: 'none'
                                },
                                '.pr-rd-author-nickname': {
                                    order: '1',
                                    marginRight: {base: '2', md: '0'},
                                    span: {
                                        color: '#000',
                                        fontWeight: 'medium',
                                        lineHeight: '6',
                                        fontSize: 'md'
                                    },
                                    '.pr-rd-bold': {
                                        display: 'none'
                                    }
                                },
                                '.pr-rd-author-submission-date': {
                                    order: '2',
                                    span: {
                                        color: '#7A7257',
                                        fontWeight: 'medium',
                                        lineHeight: '6',
                                        fontSize: 'md'
                                    },
                                    '.pr-rd-bold': {
                                        display: 'none'
                                    }
                                }
                            },
                            '.pr-rd-reviewer-type': {
                                margin: '0',
                                padding: '4px 6px',
                                border: '1px solid #3D9850',
                                borderRadius: 'lg',
                                '.pr-badging-icon': {
                                    width: '16px',
                                    height: '16px'
                                },
                                '.pr-rd-badging-text': {
                                    color: '#3D9850',
                                    fontSize: 'sm',
                                    fontWeight: 'extrabold',
                                    lineHeight: 'normal'
                                }
                            }
                        },
                        '.pr-rd-description-text': {
                            paddingLeft: {base: '0', md: '180px'},
                            fontWeight: 'medium',
                            color: '#000',
                            lineHeight: '6',
                            fontSize: 'md'
                        }
                    },
                    '&.pr-rd-images': {
                        paddingLeft: {base: '0', md: '180px'},
                        '.pr-rd-image-container': {
                            width: {base: '120px', md: '160px'},
                            height: {base: '120px', md: '160px'},
                            borderRadius: 'lg',
                            top: 'auto',
                            transform: 'unset',
                            margin: '8px 16px 8px 0',
                            img: {
                                borderRadius: 'lg',
                                width: {base: '120px', md: '160px'}
                            }
                        }
                    },
                    '&.pr-rd-footer': {
                        paddingLeft: {base: '0', md: '180px'},
                        backgroundColor: 'unset',
                        paddingBottom: '0',
                        '.pr-rd-bottomline': {
                            marginBottom: '2',
                            span: {
                                color: '#000',
                                fontWeight: 'medium',
                                lineHeight: '6',
                                fontSize: 'md'
                            },
                            '.pr-rd-bold': {
                                fontWeight: 'extrabold'
                            }
                        },
                        '.pr-rd-helpful-action': {
                            '.pr-rd-helpful-action-group': {
                                display: {base: 'block', md: 'flex'}
                            },
                            '.pr-rd-helpful-text': {
                                color: '#7A7257',
                                fontWeight: 'medium',
                                lineHeight: '6',
                                fontSize: 'md',
                                float: {base: 'left', md: 'unset'}
                            },
                            '.pr-rd-helpful-action-btn-group': {
                                margin: '0 16px 0 8px',
                                paddingRight: '4',
                                float: {base: 'left', md: 'unset'},
                                '.pr-helpful-btn': {
                                    border: 'none',
                                    padding: '0',
                                    margin: 0
                                }
                            },
                            '.pr-rd-flag-review-container': {
                                width: {base: '100%', md: 'auto'},
                                clear: {base: 'both', md: 'unset'}
                            },
                            '.pr-rd-flag-review-btn': {
                                color: '#7A7257',
                                fontWeight: 'medium',
                                lineHeight: '6',
                                fontSize: 'md',
                                width: {base: '100%', md: 'auto'},
                                textAlign: {base: 'left', md: 'center'},
                                display: 'none'
                            }
                        }
                    }
                }
            },
            '.pr-rd-main-footer': {
                display: 'none'
            }
        }
    }
}
